import React, { useState, useContext } from 'react';
import { actions, StateContext } from "../state";
import BaseContent from "./BaseContent";
import Button, { ButtonContainer } from './library/Buttons';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSyncAlt } from '@fortawesome/free-solid-svg-icons';
import { fetchPaymentStatus } from "../api";
import { ERROR_TYPES, PAYMENT_STATUSES, TOKEN_TYPES } from "../utils/enums";
import { get } from "lodash/object";
import { useTranslation } from 'react-i18next';
import { logUiError } from "../utils/logging";
import { transformStatusErrorMessage } from '../utils/errors';

export const PendingTransaction = () => {
  const [applicationState, dispatch] = useContext(StateContext);
  const [isFetching, setIsFecthing] = useState(false);
  const [t, i18n] = useTranslation(); // eslint-disable-line no-unused-vars
  const {configuration, payment, tokens} = applicationState;

  const checkStatus = async () => {
    setIsFecthing(true);
    const response = await fetchPaymentStatus(payment.id, tokens[TOKEN_TYPES.VALIDATE_PAYMENT].access_token);
    const {status, message} = response.data;
    setIsFecthing(false);

    if(status === PAYMENT_STATUSES.COMPLETE){
      dispatch(actions.payment.updatePayment({status}));
    }
    else if([PAYMENT_STATUSES.PENDING_ACCEPTANCE, PAYMENT_STATUSES.FAILED].includes(status)){
      const errorType = ERROR_TYPES.UI_ERRORS.FAILED_PAYMENT;
      const errorDescription = transformStatusErrorMessage(message, configuration.acceptPayment.errorMessages) || get(configuration, `errors.uiErrors.${errorType}.description`);

      dispatch(actions.modals.showUiErrorModal(configuration, {
        errorType: errorType,
        contentProps: {
          showFaqLink: false,
          // description: message ? `${message} Please try your request again or select a different payment network.` : get(configuration, `errors.uiErrors.${errorType}.description`),
          description: errorDescription,
          actions: [
            {
              label: "Return to Paywall",
              onClick: () => {
                dispatch(actions.payment.updatePayment({status}));
                dispatch(actions.tokens.resetTokens());
                dispatch(actions.selectedPaymentNetwork.resetSelectedPaymentNetwork());
              }
            }
          ]
        }
      }));

      logUiError(errorType, applicationState, {errorDescription});
    }
  };

  return (
    <BaseContent {...configuration.pendingTransaction}>
      <ButtonContainer>
        <Button style={{marginBottom: '2em'}} collapsible onClick={checkStatus} loading={isFetching}>{t('checkPaymentStatus')}{!isFetching && <FontAwesomeIcon style={{marginLeft: '10px'}} icon={faSyncAlt} size="lg"/>}</Button>
      </ButtonContainer>
    </BaseContent>
  );
};

export default PendingTransaction;
